export default __webpack_public_path__ + "static/media/invitation-con1.8f48795b.gif";